(function(){
    'use strict';

    angular.module('elogbooks.common.waste-treatment-types', []);
})();